"use client";

import { useFormStatus } from "react-dom";
import { Button } from "../ui/button";
import { ReloadIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";
import {
  ButtonHTMLAttributes,
  ComponentProps,
  Dispatch,
  HTMLAttributes,
  SetStateAction,
} from "react";

interface SubmitButtonProps extends ComponentProps<"button"> {
  text: string;
  loadingText: string;
}

export function NewSubmitButton(props: SubmitButtonProps) {
  const { pending } = useFormStatus();

  if (pending) {
    return (
      <Button disabled className={cn(props.className, "")}>
        <ReloadIcon className="mr-2 h-4 w-4 animate-spin" />
        {props.loadingText}
      </Button>
    );
  } else {
    return (
      <Button
        disabled={props.disabled}
        type="submit"
        className={cn(props.className, "")}
        {...props}
      >
        {props.text}
      </Button>
    );
  }
}

export function SubmitBtn({
  className,
  text,
  loadingText,
  disabled = false,
  props,
}: {
  className?: string;
  text: string;
  loadingText: string;
  disabled?: boolean;
  props?: ButtonHTMLAttributes<HTMLButtonElement>;
}) {
  const { pending } = useFormStatus();

  if (pending) {
    return (
      <Button disabled className={cn(className, "")}>
        <ReloadIcon className="mr-2 h-4 w-4 animate-spin" />
        {loadingText}
      </Button>
    );
  } else {
    return (
      <Button
        disabled={disabled}
        type="submit"
        className={cn(className, "")}
        {...props}
      >
        {text}
      </Button>
    );
  }
}
